@if(filtersEnabled && filterOptions.length > 0) {
<finxone-web-frontend-finx-tags-container
  [filterOptions]="filterOptions"
  [filtersEnabled]="filtersEnabled"
  [filterMarginStyle]="filterMarginStyle"
  (filterChange)="onFilterChange($event)"
  [attri]="attri"
  [hideFilterCloseIcon]="true"
></finxone-web-frontend-finx-tags-container>
}
<div
  class="scrollable z-index-3 position-relative pointer-events-none"
  id="chats-list"
  [ngStyle]="pageConfig?.isUsingHtmlStructure ? { maxHeight: containerHeight } : {}"
  (scroll)="onScroll($event)"
>
  @if ( chatsList && chatsList.length > 0) { @for (chat of chatsList; track
  chat.id) {
  <finxone-web-frontend-list-item
    [customHandlebarModel]="chat"
    [content]="content"
    (itemClicked)="onChatClick(chat)"
    [customClass]="'pointer-events-none ' + (chat.id === activeChatId ? 'active-chat' : '')"
    [textContentStyle]="hasCustomStyles ? {} : getWidgetStyles(chat)"
    [gestures]="attri?.widgetProperties?.gestures"
    [listActions]="attri?.['listActions']"
  ></finxone-web-frontend-list-item>
  } } @else if (isLoading) {
  <div [innerHTML]="renderFetchingTemplateFunction() | safeHtml"></div>
  } @else {
  <div [innerHTML]="renderNoRecordsTemplate() | safeHtml"></div>
  }
</div>
